import React from 'react'

export default function tables2() {
  return (
    <>
    <h3 className="d-card-title">Projects</h3>
    <div><table className='table1'>
    <tr>
      <th>Projects</th>
      <th>By :-</th>
      <th>Tech Stack</th>
    </tr>
    <tr>
      <td>Tourist Guide</td>
      <td>Kartikey Singhal and Team</td>
      <td>React js, Google Maps  API,Rapid APIHTML CSS JS</td>
    </tr>
    <tr>
      <td>PACOME</td>
      <td>Avinesh  and Team.</td>
      <td>React native, AWS amplify  and app sync, dynamo DB.</td>
    </tr>
    <tr>
      <td>Protek IT Solution</td>
      <td>Sachin Kumar and Team</td>
      <td>HTML,	CSS,	JAVASCRIPT,
Bootstrap, tailwind CSS,  Firebase,  Figma</td>
    </tr>
    <tr>
      <td>Quiz Portal</td>
      <td>Sachin Kumar and Team</td>
      <td> HTML, CSS,  JAVASCRIPT,
Bootstrap,	tailwind	CSS,	Firebase,  Figma</td>
    </tr>
    <tr>
      <td>Restaurant Website</td>
      <td>Siddharth Srivastava and team</td>
      <td>HTML, CSS, JAVASCRIPT,
Bootstrap</td>
    </tr>
    <tr>
      <td>E-Drishti</td>
      <td>Nishtha Pandey and Team</td>
      <td>Flutter, Dart, Firebase, Machine  learning</td>
    </tr>
    <tr>
      <td>Grameen Neeti</td>
      <td>Anjani Singhal ,Nidhi  Solanki
,Shashwat Pandey,Sachin Kumar,Kamakshi  Vashista,Harshit Saxena
</td>
<td>Flutter, Machine learning</td>
    </tr>
    <tr>
    <td>Docrafi</td>
      <td>Mrithunjay N. Pandey and  Team
</td>
<td>HTML,	CSS,	JAVASCRIPT,
AWS,	Cognito	,S3,	Lambda	and	API  Gateway</td>
    </tr>
  </table></div>
  </>
  )
}
